import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import BotonInformacion from "../../../components/helpers/BotonInformacion";
import { ShowDateToUser } from "../../../components/ShowDateToUser";
import { fetchAxiosToken } from "../../../helpers/fetchAxiosToken";
import { useAppSelector } from "../../../hooks/hooks";
import { NavbarBroker } from "../../dashboardBroker/NavbarBroker";
import { NavbarMobileBroker } from "../../dashboardBroker/NavbarMobileBroker";
import { NavbarHotel } from "../NavbarHotel";
import { NavbarMobileHotel } from "../NavbarMobileHotel";
import { NavbarClienteHotel } from "../../dashboardClientesHotel/NavbarClienteHotel";
import { NavbarMobileClienteHotel } from "../../dashboardClientesHotel/NavbarMobileClienteHotel";
import { NavbarCliente } from "../../dashboardClientes/NavbarCliente";
import { NavbarMobileCliente } from "../../dashboardClientes/NavbarMobileCliente";

import { ModalDetalleDePagos } from "./ModalDetalleDePagos";
import { formatearNumero } from "../../../components/helpers/formatearNumero";
import ModalAgregarTour from "./ModalAgregarTour";
import ModalAgregarServicio from "./ModalAgregarServicio";
import { ModalHuespedes } from "./ModalHuespedes";
import { ModalHabitacion } from "./ModalHabitacion";

export interface Pedido {
    id: number;
    id_cliente: number;
    id_habitacion: number;
    id_hotel: number;
    costo_alquiler: string;
    garantia: string;
    tipo_garantia: string | null;
    descuento_estadia: string;
    descuento_cupon: string;
    costo_servicios_adicionales: string;
    costo_total: string;
    pagado: string;
    saldo: string;
    habilitado: string;
    estado: string;
    fecha_inicio: string;
    fecha_final: string;
    tipo_moneda: string;
    fecha_registro: string;
    adultos: number;
    ninos: number;
    oferta: any;
    expiracion: any;
    pedidos_servicios_adicionales: PedidosServiciosAdicionale[];
    HotelHabitaciones: HotelHabitaciones;
    pedidos_tours: PedidosTour[];
    costo_total_tour: number;
    igv: string | null;
    costo_subtotal?: string | null;
    factura_pedido_habitaciones?: {
        id: number;
        id_pedido_habitacion: number;
        id_pedido_pago_habitacion: number;
        id_factura: number;
        factura: {
            id: string;
            costo: string;
            tipo_factura: string;
        };
    }[];
}

export interface PedidosServiciosAdicionale {
    id: number;
    id_pedido: any;
    id_pedido_habitaciones: number;
    servicio: string;
    costo: string;
    igv: string;
}
export interface HotelHabitaciones {
    id: number;
    nombre: string;
    banner: string;
    casa: Casa;
}
export interface Casa {
    nombre: string;
    banner: string;
    Propietario: Propietario;
}
export interface Propietario {
    nombre: string;
    apellido: string;
    correo: string;
    avatar: string;
    banco: any;
    tipo_cuenta: any;
    tipo_moneda: string;
    titular_cuenta: any;
    tipo_documento: any;
    numero_documento: any;
    numero_cuenta: any;
    cci: any;
}
export interface PedidosTour {
    id: number;
    id_tour: number;
    id_pedido_habitaciones: number;
    hora_inicio: string;
    hora_final: string;
    precio_simple: string;
    numero_adultos: number;
    numero_ninos: number;
    precio_tour: string;
    fecha: string;
    hotel_tour: HotelTour;
    precio_igv: string;
}
export interface HotelTour {
    id: number;
    nombre: string;
    banner: string;
    casa: Casa2;
}
export interface Casa2 {
    id: number;
    nombre: string;
    banner: string;
    Propietario: Propietario2;
}
export interface Propietario2 {
    id: number;
    nombre: string;
    apellido: string;
    avatar: string;
}

export const ReservaDetalleHotel = () => {
    const { reservaID } = useParams();
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState(false);
    const [modalHabitacion, setModalHabitacion] = useState(false);
    const { id, tipo_usuario } = useAppSelector(
        (state) => state.usuario_logeado,
    );
    const [pedido, setPedido] = useState<Pedido | null>(null);
    const [modalAddTour, setModalAddTour] = useState<boolean>(false);
    const [modalAddServicio, setModalAddServicio] = useState<boolean>(false);
    const [estado, setEstado] = useState<number | null>(1);
    const porcentaje = [5, 25, 40, 60, 80, 100];
    const estados = [
        "Confirmar disponibilidad",
        "Pendiente de pago",
        "Pago Parcial",
        "Pago Completo",
        "Reseña de casa",
        "Devolución de garantía",
    ];
    const [modalHuespedes, setModalHuespedes] = useState(false);
    const [servicios, setServicios] = useState(false);
    const { socket } = useAppSelector((state) => state.activarSocket);
    const casa = useAppSelector((state) => state.landing_house);

    const [loading, setLoading] = useState(false);
    const [selectedServicios, setSelectedServicios] = useState<number[]>([]);
    const [selectedTours, setSelectedTours] = useState<number[]>([]);
    const handleSelectTour = (tourId: number) => {
        setSelectedTours((prev) =>
            prev.includes(tourId)
                ? prev.filter((id) => id !== tourId)
                : [...prev, tourId],
        );
    };

    useEffect(() => {
        getOnePedido();
    }, [modalVisible]);

    const getOnePedido = async () => {
        fetchAxiosToken({
            url: `/pedidos_habitaciones/getOne/${reservaID}/${id}`,
        }).then((e) => {
            console.log("reserva", e);
            setPedido(e);
            if (socket) {
                socket?.emit("send-notificacion-leida", {
                    id_cliente: e.id_cliente,
                    id_casa: casa.house.id,
                });
            }
            setEstado(estados.indexOf(e.estado));
        });
    };

    const handleDisponibilidad = async (disponibilidad: string) => {
        try {
            await fetchAxiosToken({
                url: `/pedidos_habitaciones/putConfirm/${pedido?.id}`,
                body: { disponibilidad, dashboard: "Si" },
                method: "put",
            });
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                icon: "success",
                title: "Reserva notificada",
                text: `Ya le avisamos a tu cliente que ${disponibilidad} esta disponible`,
                showConfirmButton: true,
            });
            getOnePedido();
        } catch (error) {
            console.log(error);
        }
    };

    const handleSelectServicio = (id: number) => {
        setSelectedServicios((prev) =>
            prev.includes(id)
                ? prev.filter((sId) => sId !== id)
                : [...prev, id],
        );
    };

    const handleDeleteServicio = async () => {
        try {
            setLoading(true);
            const result = await Swal.fire({
                title: "¿Está seguro de eliminar los servicios adicionales?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#029BFC",
                confirmButtonText: "Sí, eliminar",
                cancelButtonText: "Cancelar",
            });

            if (result.isConfirmed) {
                await fetchAxiosToken({
                    url: `/pedidos_habitaciones/deleteAditionalService/`,
                    body: {
                        ids_servicios: selectedServicios,
                    },
                    method: "post",
                });
                Swal.fire({
                    confirmButtonColor: "#029BFC",
                    iconColor: "#029BFC",
                    icon: "success",
                    title: "Reserva notificada",
                    text: `los servicios fueron eliminados correctamente`,
                    showConfirmButton: true,
                });
                getOnePedido();
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteTour = async () => {
        try {
            setLoading(true);
            const result = await Swal.fire({
                title: "¿Está seguro de eliminar los tours?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#029BFC",
                confirmButtonText: "Sí, eliminar",
                cancelButtonText: "Cancelar",
            });
            if (result.isConfirmed) {
                await fetchAxiosToken({
                    url: `/pedidos_habitaciones/deleteTour/`,
                    body: {
                        ids_tours: selectedTours,
                    },
                    method: "post",
                });
                Swal.fire({
                    confirmButtonColor: "#029BFC",
                    iconColor: "#029BFC",
                    icon: "success",
                    title: "Reserva notificada",
                    text: `los tours fueron eliminados correctamente`,
                    showConfirmButton: true,
                });
                getOnePedido();
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const botonVolver = () => window.history.back();
    const formatearFecha = (fecha: string): string => {
        const [anio, mes, dia] = fecha.split("-");
        return `${dia}/${mes}/${anio}`;
    };

    const handleDescargarFactura = async (
        id_factura: number,
        accion: "descargar" | "abrir" = "descargar",
    ) => {
        try {
            let token = localStorage.getItem("token");
            const url = `${process.env.REACT_APP_PROXY}/pedidos_pagos_habitaciones/descargarFactura/${id_factura}`;

            const res = await fetch(url, {
                method: "GET",
                headers: {
                    authorization: `${token}`,
                    // authorization: token,
                    Accept: "application/pdf",

                    "Cache-Control": "no-cache",
                },
            });

            if (!res.ok) {
                const maybeJson = await res.text();
                try {
                    const errObj = JSON.parse(maybeJson);
                    throw new Error(
                        errObj?.message || "No se pudo descargar la factura",
                    );
                } catch {
                    throw new Error("No se pudo descargar la factura");
                }
            }

            const ct = res.headers.get("content-type") || "";
            let blob: Blob;

            if (ct.includes("application/pdf")) {
                const ab = await res.arrayBuffer();
                blob = new Blob([ab], { type: "application/pdf" });
            } else {
                const text = await res.text();

                if (text.startsWith("%PDF")) {
                    blob = new Blob([text], { type: "application/pdf" });
                } else {
                    try {
                        const bstr = atob(
                            text.replace(/^data:application\/pdf;base64,/, ""),
                        );
                        const len = bstr.length;
                        const u8 = new Uint8Array(len);
                        for (let i = 0; i < len; i++)
                            u8[i] = bstr.charCodeAt(i);
                        blob = new Blob([u8], { type: "application/pdf" });
                    } catch {
                        try {
                            const obj = JSON.parse(text);
                            throw new Error(
                                obj?.message ||
                                    "Respuesta inesperada al descargar la factura.",
                            );
                        } catch {
                            throw new Error(
                                "La respuesta no es un PDF válido.",
                            );
                        }
                    }
                }
            }

            const fileURL = URL.createObjectURL(blob);

            if (accion === "abrir") {
                window.open(fileURL, "_blank", "noopener,noreferrer");
            } else {
                const a = document.createElement("a");
                a.href = fileURL;
                a.download = `factura-${id_factura}.pdf`;
                document.body.appendChild(a);
                a.click();
                a.remove();
            }

            setTimeout(() => URL.revokeObjectURL(fileURL), 30_000);
        } catch (e: any) {
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Error",
                text: e?.message ?? "No se pudo descargar la factura.",
                icon: "error",
            });
        }
    };

    const render = () => {
        return (
            <>
                <div className="relative flex flex-col w-full p-4 mt-1 2xl:mt-4">
                    <div
                        className={
                            "flex items-center text-lg cursor-pointer pt-4 px-4 absolute top-1 left-1 "
                        }
                        onClick={botonVolver}
                    >
                        <svg
                            className="w-6 h-6 -ml-2 text-black"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <polyline points="15 18 9 12 15 6" />
                        </svg>
                        <span className="mx-1">Regresar</span>
                    </div>

                    {modalVisible && (
                        <ModalDetalleDePagos
                            modalVisible={modalVisible}
                            setModalVisible={setModalVisible}
                            idPedido={Number(reservaID)}
                            moneda={pedido?.tipo_moneda || ""}
                        />
                    )}

                    {modalAddTour && (
                        <ModalAgregarTour
                            modalVisible={modalAddTour}
                            setModalVisible={setModalAddTour}
                            tipo_moneda={pedido?.tipo_moneda || ""}
                            id_hotel={pedido?.id_hotel || 0}
                            id_pedido={pedido?.id ?? 0}
                            getOnePedido={getOnePedido}
                        />
                    )}

                    {modalAddServicio && (
                        <ModalAgregarServicio
                            modalVisible={modalAddServicio}
                            setModalVisible={setModalAddServicio}
                            tipo_moneda={pedido?.tipo_moneda || ""}
                            id_habitacion={pedido?.HotelHabitaciones?.id || 0}
                            id_pedido={pedido?.id ?? 0}
                            getOnePedido={getOnePedido}
                        />
                    )}

                    {modalHuespedes && pedido && (
                        <ModalHuespedes
                            modalVisible={modalHuespedes}
                            setModalVisible={setModalHuespedes}
                            idPedidoHabitacion={pedido.id}
                        />
                    )}

                    {modalHabitacion && pedido && (
                        <ModalHabitacion
                            modalVisible={modalHabitacion}
                            setModalVisible={setModalHabitacion}
                            id_habitacion={pedido.HotelHabitaciones.id}
                            fecha_ingreso={formatearFecha(pedido.fecha_inicio)}
                            fecha_salida={formatearFecha(pedido.fecha_final)}
                            total_huespedes={Number(
                                pedido.adultos + pedido.ninos,
                            )}
                            pedido={pedido}
                            getOnePedido={getOnePedido}
                        />
                    )}

                    <div className="relative z-10 flex items-center justify-center mx-auto w-52">
                        <p className="pr-2 text-lg font-medium text-center">
                            Pedido número #{pedido?.id}
                        </p>
                        <BotonInformacion
                            text="1. Confirmar Disponibilidad: Aca deberás aceptar la reserva para que el Cliente pueda efectuar el pago.
2. Pendiente de Pago: Estas a la espera de que el cliente realize el pago de la reserva.
3. Pago Parcial: El cliente habrá realizado el 50% del pago del Alquiler.
4. Pago Completo: El cliente habrá realizado el pago total de la Reserva.
5. Reseña de casa: El cliente habrá realizado la reseña de la reserva.
6. Devolución de garantía: Hiciste la devolución de la garantía al cliente."
                        />
                    </div>

                    <div className="mt-10 text-sm font-medium 2xl:text-base">
                        Detalles pedido del{" "}
                        <ShowDateToUser date={pedido?.fecha_inicio} /> al{" "}
                        <ShowDateToUser date={pedido?.fecha_final} />
                    </div>
                    <div className="mt-4 text-sm font-medium 2xl:text-base">
                        Estado de la reserva:{" "}
                        <span
                            className={
                                pedido?.estado !== "No disponible"
                                    ? "font-normal"
                                    : "font-normal text-red-500"
                            }
                        >
                            {pedido?.estado}
                        </span>
                    </div>

                    <div className="flex flex-col gap-2 p-4 mt-4 border w-[500px] 2xl:w-[576px] rounded-xl mx-auto">
                        <div className="flex justify-between">
                            <label className="text-sm font-medium 2xl:text-base"></label>
                            <div
                                onClick={() => setModalHabitacion(true)}
                                className="cursor-pointer text-sm flex justify-center items-center gap-2 p-2 rounded-lg border-2 border-[#1C4CBB] text-[#1C4CBB] hover:text-white hover:bg-[#1C4CBB] "
                            >
                                Editar alquiler
                                <div>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="w-6 h-6"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div className="flex justify-between">
                            <label className="text-sm font-medium 2xl:text-base">
                                Costo alquiler
                            </label>
                            <div className="text-sm 2xl:text-base">
                                {formatearNumero(
                                    Number(pedido?.costo_alquiler),
                                )}{" "}
                                {pedido?.tipo_moneda}
                            </div>
                        </div>

                        {Number(pedido?.descuento_cupon) > 0 && (
                            <div className="flex justify-between text-green-500">
                                <label className="text-sm font-medium 2xl:text-base">
                                    Descuento cupón
                                </label>
                                <div className="text-sm 2xl:text-base">
                                    -{" "}
                                    {formatearNumero(
                                        Number(pedido?.descuento_cupon),
                                    )}{" "}
                                    {pedido?.tipo_moneda}
                                </div>
                            </div>
                        )}

                        {pedido?.tipo_garantia !== "Efectivo" && (
                            <>
                                <hr className="my-1" />
                                <div className="flex justify-between">
                                    <label className="text-sm font-medium 2xl:text-base">
                                        Garantía
                                    </label>
                                    <div className="text-sm 2xl:text-base">
                                        {formatearNumero(
                                            Number(pedido?.garantia),
                                        )}{" "}
                                        {pedido?.tipo_moneda}
                                    </div>
                                </div>
                            </>
                        )}

                        <hr className="my-1 border-gray-700 " />
                        {Number(pedido?.descuento_estadia) > 0 && (
                            <>
                                <div className="flex justify-between">
                                    <label className="text-sm font-medium 2xl:text-base">
                                        Descuento larga estadía
                                    </label>
                                    <div className="text-sm 2xl:text-base">
                                        -{" "}
                                        {formatearNumero(
                                            Number(pedido?.descuento_estadia),
                                        )}{" "}
                                        {pedido?.tipo_moneda}
                                    </div>
                                </div>
                                <hr className="my-1" />
                            </>
                        )}

                        {pedido && (
                            <>
                                <div
                                    onClick={() => setServicios(!servicios)}
                                    className="flex justify-between hover:cursor-pointer"
                                >
                                    <div className="flex items-center">
                                        {!servicios ? (
                                            <svg
                                                className="w-5 h-5 text-black"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                strokeWidth="2"
                                                stroke="currentColor"
                                                fill="none"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path
                                                    stroke="none"
                                                    d="M0 0h24v24H0z"
                                                />
                                                <path
                                                    d="M18 15l-6-6l-6 6h12"
                                                    transform="rotate(90 12 12)"
                                                />
                                            </svg>
                                        ) : (
                                            <svg
                                                className="w-5 h-5 text-black"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                strokeWidth="2"
                                                stroke="currentColor"
                                                fill="none"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path
                                                    stroke="none"
                                                    d="M0 0h24v24H0z"
                                                />
                                                <path
                                                    d="M18 15l-6-6l-6 6h12"
                                                    transform="rotate(180 12 12)"
                                                />
                                            </svg>
                                        )}
                                        <div className="flex items-center justify-center gap-2 text-sm font-medium 2xl:text-base">
                                            Servicios Adicionales{" "}
                                            <div
                                                onClick={() =>
                                                    setModalAddServicio(true)
                                                }
                                                className="px-3 py-1 text-xs text-white transition-all duration-200 ease-in-out bg-blue-500 rounded-lg cursor-pointer hover:scale-105"
                                            >
                                                Agregar Servicio
                                            </div>
                                        </div>
                                    </div>
                                    {!servicios && (
                                        <div className="text-sm 2xl:text-base">
                                            {formatearNumero(
                                                Number(
                                                    pedido?.costo_servicios_adicionales,
                                                ),
                                            )}{" "}
                                            {pedido?.tipo_moneda}
                                        </div>
                                    )}
                                </div>

                                {/* Lista de servicios adicionales con checkbox */}
                                {servicios &&
                                    pedido?.pedidos_servicios_adicionales.map(
                                        (service) => (
                                            <div
                                                key={service.id}
                                                className="flex justify-between items-center mt-2"
                                            >
                                                <div className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedServicios.includes(
                                                            service.id,
                                                        )}
                                                        onChange={() =>
                                                            handleSelectServicio(
                                                                service.id,
                                                            )
                                                        }
                                                        className="w-5 h-5 accent-blue-600 cursor-pointer"
                                                    />
                                                    <label className="text-sm 2xl:text-base">
                                                        {service.servicio}
                                                    </label>
                                                </div>

                                                <div className="text-sm 2xl:text-base">
                                                    {formatearNumero(
                                                        Number(service?.costo),
                                                    )}{" "}
                                                    {pedido.tipo_moneda}
                                                </div>
                                            </div>
                                        ),
                                    )}

                                {/* Botón para eliminar servicios seleccionados */}
                                {pedido?.pedidos_servicios_adicionales?.length >
                                    0 &&
                                    servicios && (
                                        <div className="flex justify-end mt-4">
                                            <button
                                                onClick={handleDeleteServicio}
                                                disabled={
                                                    loading ||
                                                    selectedServicios.length ===
                                                        0
                                                }
                                                className={`px-4 py-2 rounded-lg font-semibold text-white transition-all duration-200 ${
                                                    selectedServicios.length ===
                                                    0
                                                        ? "bg-gray-400 cursor-not-allowed"
                                                        : "bg-red-500 hover:bg-red-600"
                                                }`}
                                            >
                                                {loading
                                                    ? "Eliminando..."
                                                    : `Eliminar ${
                                                          selectedServicios.length >
                                                          1
                                                              ? "servicios seleccionados"
                                                              : "servicio seleccionado"
                                                      }`}
                                            </button>
                                        </div>
                                    )}
                                <hr className="my-1 border-[#1C4CBB]" />
                            </>
                        )}

                        {pedido && (
                            <>
                                <div
                                    onClick={() => setServicios(!servicios)}
                                    className="flex justify-between hover:cursor-pointer"
                                >
                                    <div className="flex items-center">
                                        {!servicios ? (
                                            <svg
                                                className="w-5 h-5 text-black"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                strokeWidth="2"
                                                stroke="currentColor"
                                                fill="none"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path
                                                    stroke="none"
                                                    d="M0 0h24v24H0z"
                                                />
                                                <path
                                                    d="M18 15l-6-6l-6 6h12"
                                                    transform="rotate(90 12 12)"
                                                />
                                            </svg>
                                        ) : (
                                            <svg
                                                className="w-5 h-5 text-black"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                strokeWidth="2"
                                                stroke="currentColor"
                                                fill="none"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path
                                                    stroke="none"
                                                    d="M0 0h24v24H0z"
                                                />
                                                <path
                                                    d="M18 15l-6-6l-6 6h12"
                                                    transform="rotate(180 12 12)"
                                                />
                                            </svg>
                                        )}
                                        <div className="flex items-center justify-center gap-2 text-sm font-medium 2xl:text-base">
                                            Tours{" "}
                                            <div
                                                onClick={() =>
                                                    setModalAddTour(true)
                                                }
                                                className="px-3 py-1 text-xs text-white transition-all duration-200 ease-in-out bg-blue-500 rounded-lg cursor-pointer hover:scale-105"
                                            >
                                                Agregar Tour
                                            </div>
                                        </div>
                                    </div>
                                    {!servicios && (
                                        <div className="text-sm 2xl:text-base">
                                            {formatearNumero(
                                                Number(
                                                    pedido?.costo_total_tour,
                                                ),
                                            )}{" "}
                                            {pedido?.tipo_moneda}
                                        </div>
                                    )}
                                </div>
                                {servicios &&
                                    pedido?.pedidos_tours.map((tour) => (
                                        <div key={tour.id}>
                                            <div className="flex justify-between w-full mt-2 items-center">
                                                <div className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedTours.includes(
                                                            tour.id,
                                                        )}
                                                        onChange={() =>
                                                            handleSelectTour(
                                                                tour.id,
                                                            )
                                                        }
                                                        className="w-5 h-5 accent-blue-600 cursor-pointer"
                                                    />
                                                    <span className="font-semibold">
                                                        Tour
                                                    </span>
                                                </div>

                                                <div className="flex items-center gap-2">
                                                    {tour.hotel_tour.nombre}
                                                </div>
                                            </div>

                                            <div className="flex justify-between w-full mt-2">
                                                <span className="font-semibold">
                                                    Turno
                                                </span>
                                                <span>
                                                    {formatearFecha(tour.fecha)}{" "}
                                                    ({tour.hora_inicio} -{" "}
                                                    {tour.hora_final})
                                                </span>
                                            </div>

                                            <div className="flex justify-between w-full mt-2">
                                                <span className="font-semibold">
                                                    Precio Tour por persona
                                                </span>
                                                <span>
                                                    {formatearNumero(
                                                        Number(
                                                            tour.precio_simple,
                                                        ),
                                                    )}{" "}
                                                    {pedido.tipo_moneda} X (
                                                    {Number(
                                                        tour.numero_adultos,
                                                    ) +
                                                        Number(
                                                            tour.numero_ninos,
                                                        )}{" "}
                                                    Personas)
                                                </span>
                                            </div>

                                            <div className="flex justify-between w-full mt-2">
                                                <span className="font-bold">
                                                    Precio Tour
                                                </span>
                                                <span className="font-semibold">
                                                    {formatearNumero(
                                                        Number(
                                                            tour.precio_tour,
                                                        ),
                                                    )}{" "}
                                                    {pedido.tipo_moneda}
                                                </span>
                                            </div>

                                            <hr className="my-4 border-[#1C4CBB]" />
                                        </div>
                                    ))}

                                {/* Botón de eliminar tours seleccionados */}
                                {pedido?.pedidos_tours?.length > 0 &&
                                    servicios && (
                                        <div className="flex justify-end mt-4">
                                            <button
                                                onClick={handleDeleteTour}
                                                disabled={
                                                    loading ||
                                                    selectedTours.length === 0
                                                }
                                                className={`px-4 py-2 rounded-lg font-semibold text-white transition-all duration-200 ${
                                                    selectedTours.length === 0
                                                        ? "bg-gray-400 cursor-not-allowed"
                                                        : "bg-red-500 hover:bg-red-600"
                                                }`}
                                            >
                                                {loading
                                                    ? "Eliminando..."
                                                    : `Eliminar ${
                                                          selectedTours.length >
                                                          1
                                                              ? "tours seleccionados"
                                                              : "tour seleccionado"
                                                      }`}
                                            </button>
                                        </div>
                                    )}
                                <hr className="my-1 border-gray-700 " />
                            </>
                        )}

                        <div className="w-full border-4 rounded-lg border-blue-600 p-2 ">
                            {pedido?.costo_subtotal && (
                                <>
                                    <div className="flex justify-between">
                                        <label className="text-sm font-medium 2xl:text-base">
                                            Sub-total
                                        </label>
                                        <div className="text-sm 2xl:text-base">
                                            {formatearNumero(
                                                Number(pedido?.costo_subtotal),
                                            )}{" "}
                                            {pedido?.tipo_moneda}
                                        </div>
                                    </div>
                                </>
                            )}

                            {pedido?.factura_pedido_habitaciones &&
                                pedido.factura_pedido_habitaciones.length >
                                    0 && (
                                    <>
                                        <hr className="my-1 border-gray-700 " />
                                        <div className="flex items-center justify-between ">
                                            <label className="text-sm font-medium 2xl:text-base">
                                                IGV
                                            </label>
                                            <div className="flex items-center gap-2 flex-wrap">
                                                {pedido?.factura_pedido_habitaciones &&
                                                    pedido
                                                        .factura_pedido_habitaciones
                                                        .length > 0 &&
                                                    pedido.factura_pedido_habitaciones.map(
                                                        (
                                                            fp: any,
                                                            index: number,
                                                        ) => (
                                                            <button
                                                                key={fp.id}
                                                                className="px-3 py-1 text-xs text-white rounded-lg bg-[#1C4CBB] hover:opacity-90"
                                                                onClick={() =>
                                                                    handleDescargarFactura(
                                                                        fp.id_factura,
                                                                        "abrir",
                                                                    )
                                                                }
                                                            >
                                                                Ver{" "}
                                                                {fp.factura
                                                                    .tipo_comprobante ===
                                                                "Factura"
                                                                    ? "Factura"
                                                                    : fp.factura
                                                                            .tipo_comprobante ===
                                                                        "Boleta"
                                                                      ? "Boleta"
                                                                      : fp
                                                                              .factura
                                                                              .tipo_comprobante ===
                                                                          "Nota de Credito"
                                                                        ? "Nota de Crédito"
                                                                        : "Nota de Débito"}{" "}
                                                                {fp.factura
                                                                    .tipo_factura ===
                                                                "Habitación"
                                                                    ? "Hospedaje"
                                                                    : fp.factura
                                                                            .tipo_factura ===
                                                                        "Tour"
                                                                      ? "( Tour"
                                                                      : "( Adicionales"}
                                                                #
                                                                {
                                                                    fp.factura
                                                                        .serie
                                                                }
                                                                -
                                                                {
                                                                    fp.factura
                                                                        .numero
                                                                }
                                                                {") "}
                                                            </button>
                                                        ),
                                                    )}
                                            </div>
                                            <div className="flex items-center gap-2 p">
                                                <div className="text-sm 2xl:text-base">
                                                    {formatearNumero(
                                                        Number(pedido.igv),
                                                    )}{" "}
                                                    {pedido?.tipo_moneda}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}

                            <hr className="my-1 border-gray-700 " />
                            <div className="flex justify-between">
                                <label className="text-sm font-medium 2xl:text-base">
                                    Costo total
                                </label>
                                <div className="text-sm 2xl:text-base">
                                    {formatearNumero(
                                        Number(pedido?.costo_total),
                                    )}{" "}
                                    {pedido?.tipo_moneda}
                                </div>
                            </div>
                        </div>
                        <hr className="my-1 border-gray-700 " />
                        <div className="flex justify-between">
                            <label className="text-sm font-medium 2xl:text-base">
                                Pagado
                            </label>
                            <div className="text-sm 2xl:text-base">
                                {formatearNumero(Number(pedido?.pagado))}{" "}
                                {pedido?.tipo_moneda}
                            </div>
                        </div>

                        <hr className="my-1 border-gray-700 " />
                        <div className="flex justify-between">
                            <label className="text-sm font-medium 2xl:text-base">
                                Saldo
                            </label>
                            <div className="text-sm 2xl:text-base">
                                {formatearNumero(Number(pedido?.saldo))}{" "}
                                {pedido?.tipo_moneda}
                            </div>
                        </div>

                        {pedido?.garantia !== "0.00" &&
                            pedido?.tipo_garantia === "Efectivo" && (
                                <div className="flex w-full px-1 mt-4 bg-blue-200 border-4 border-blue-300 rounded-lg">
                                    <span className="underline">
                                        Garantía:{" "}
                                    </span>
                                    {tipo_usuario === 5 ? (
                                        <span className="ml-2 italic font-thin">
                                            Deberás pagar{" "}
                                            {formatearNumero(
                                                Number(pedido.garantia),
                                            )}{" "}
                                            {pedido?.tipo_moneda} en efectivo al
                                            momento de llegar a la propiedad
                                        </span>
                                    ) : (
                                        <span className="ml-2 italic font-thin">
                                            El cliente pagará{" "}
                                            {formatearNumero(
                                                Number(pedido.garantia),
                                            )}{" "}
                                            {pedido?.tipo_moneda} en efectivo al
                                            momento de llegar a la propiedad
                                        </span>
                                    )}
                                </div>
                            )}
                    </div>

                    {pedido?.estado === "Confirmar disponibilidad" &&
                    tipo_usuario === 8 ? (
                        <div className="flex flex-col items-center justify-center w-full mx-auto text-center">
                            <button
                                onClick={() => handleDisponibilidad("Si")}
                                className="2xl:w-3/5 w-2/5 p-3 mt-4 font-medium text-white border rounded-lg bg-[#119b0e] active:translate-y-1 mx-auto"
                            >
                                Si esta disponible
                            </button>
                            <button
                                onClick={() => handleDisponibilidad("No")}
                                className="2xl:w-3/5 w-2/5 p-3 mt-4 font-medium text-white border rounded-lg bg-[#029BFC] active:translate-y-1 mx-auto"
                            >
                                No esta disponible
                            </button>
                        </div>
                    ) : null}

                    {pedido?.estado !== "Confirmar disponibilidad" &&
                    pedido?.estado !== "No disponible" ? (
                        <div className="w-full text-center">
                            <button
                                onClick={() => setModalVisible(true)}
                                className="2xl:w-3/5 w-2/5 p-3 mt-4 font-medium text-white rounded-lg bg-[#029BFC] active:translate-y-1"
                            >
                                Detalles de pago
                            </button>
                        </div>
                    ) : null}

                    {tipo_usuario === 8 && pedido ? (
                        <div className="w-full text-center">
                            <button
                                onClick={() => setModalHuespedes(true)}
                                className="2xl:w-3/5 w-2/5 p-3 mt-4 font-medium text-white rounded-lg bg-[#1C4CBB] active:translate-y-1"
                            >
                                Gestionar huéspedes
                            </button>
                        </div>
                    ) : null}

                    {pedido?.estado === "Pendiente de pago" ||
                    pedido?.estado === "Pago Parcial" ? (
                        <div className="w-full text-center">
                            <button
                                onClick={() =>
                                    navigate(
                                        `/checkout-hotel/${
                                            tipo_usuario === 8
                                                ? "pagar-admin/"
                                                : ""
                                        }${reservaID}`,
                                        { replace: false },
                                    )
                                }
                                className="2xl:w-3/5 w-2/5 p-3 mt-4 font-medium text-white border rounded-lg bg-[#029BFC] active:translate-y-1"
                            >
                                Pagar reserva
                            </button>
                        </div>
                    ) : null}
                </div>
            </>
        );
    };

    if (!pedido)
        return (
            <>
                <NavbarHotel titulo="Reservas">
                    <div className="p-4 font-medium">Cargando pedido...</div>
                    <NavbarMobileHotel />
                </NavbarHotel>
            </>
        );

    return (
        <>
            {tipo_usuario === 8 ? (
                <NavbarHotel titulo="Reserva">
                    {render()}
                    <NavbarMobileHotel />
                </NavbarHotel>
            ) : tipo_usuario === 9 ? (
                <NavbarClienteHotel>
                    {render()}
                    <NavbarMobileClienteHotel />
                </NavbarClienteHotel>
            ) : tipo_usuario === 5 || tipo_usuario === 7 ? (
                <NavbarCliente>
                    {render()}
                    <NavbarMobileCliente />
                </NavbarCliente>
            ) : tipo_usuario === 6 ? (
                <NavbarBroker titulo="Reserva">
                    {render()}
                    <NavbarMobileBroker />
                </NavbarBroker>
            ) : null}
        </>
    );
};
